import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { OrgVariablesModel } from '@models/org-variables.model';

@Injectable({
  providedIn: 'root',
})
export class OrgVariablesService {
  constructor(private http: HttpClient) {}

  public getVariables(): Observable<OrgVariablesModel.Variable[]> {
    return this.http.get<OrgVariablesModel.Variable[]>(api.orgVariables.crud);
  }

  public createVariables(variable: OrgVariablesModel.Variable): Observable<OrgVariablesModel.Variable> {
    return this.http.post<OrgVariablesModel.Variable>(api.orgVariables.crud, { ...variable });
  }

  public updateVariables(variable: OrgVariablesModel.Variable): Observable<OrgVariablesModel.Variable> {
    return this.http.put<OrgVariablesModel.Variable>(api.orgVariables.crud, { ... variable });
  }

  public removeVariable(name: string) {
    return this.http.delete(`${api.orgVariables.crud}?name=${name}`);
  }
}
